import { render, staticRenderFns } from "./UserBalance.vue?vue&type=template&id=e8136d42&"
import script from "./UserBalance.vue?vue&type=script&lang=js&"
export * from "./UserBalance.vue?vue&type=script&lang=js&"
import style0 from "./UserBalance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports